import React from "react";
import axios from 'axios';
import './IndexMain.css';

import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";

import BronzeOffer from "../Offers/BronzeOffer";
import SilverOffer from "../Offers/SilverOffer";
import GoldOffer from "../Offers/GoldOffer";
import LatestNews from "../Posts/LatestNews";

import BTC from "../../../img/WithdrawalPage/BTC.png";
import ETH from "../../../img/WithdrawalPage/ETH.png";
import LTC from "../../../img/WithdrawalPage/LTC.png";
import USDT from "../../../img/WithdrawalPage/USDT.png";
import BNB from "../../../img/WithdrawalPage/bnb.png";
import BUSD from "../../../img/WithdrawalPage/busd.png";
import TRX from "../../../img/WithdrawalPage/trx.png";
import icoinfo from "../../../img/WithdrawalPage/ico-info02.jpg";
import paypal from "../../../img/WithdrawalPage/paypal.png";
import payeer from "../../../img/WithdrawalPage/payeer.jpg";

import fav from "../../../img/IndexMain/favicon-32x32.png";
import { indexLang } from "./indexMainLang";

class IndexMain extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            session : this.props.session,
            email: this.props.session.email,
            Balance:  this.props.session.Balance,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        };
        this.buySomething = this.buySomething.bind(this);

    }

    buySomething = (event, buySomething) => {
        event.preventDefault();
        buySomething().then(({data}) => {
            console.log('buyUniten работает',data.buySomething);
            //this.setState({Balance : data.giveMoney.Balance})
        })
    };

    componentDidMount() {
        let client = window.navigator ? (window.navigator.language ||
			window.navigator.systemLanguage ||
			window.navigator.userLanguage) : ("en-US");

		let language = (client.search('-') > 0) ?
			client.substring(0, client.search('-')).toLowerCase() :
			client.toLowerCase();

		if (!localStorage.getItem('lang') && language == 'ru') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
            // location.reload();
		}

		if (!localStorage.getItem('lang') && language == 'fr') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
            // location.reload();
		}

		if (!localStorage.getItem('lang') && language == 'de') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : language});
            // location.reload();
		}

		if (!localStorage.getItem('lang') && language == 'en') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "en");
            this.setState({Language : "en"});
            // location.reload();
		}

        if (!localStorage.getItem('lang') && language == 'zh') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "ch");
            // this.setState({Language : "ch"});
		}

		if (!localStorage.getItem('lang') && language == 'ko') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : "ko"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'it') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', language);
            this.setState({Language : "it"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'jа') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "jap");
            this.setState({Language : "jap"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'pt') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "port");
            this.setState({Language : "port"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'tr') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "turk");
            this.setState({Language : "turk"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'vi') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "viet");
            this.setState({Language : "viet"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'es') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "spa");
            this.setState({Language : "spa"});
            // location.reload();
		}
		
		if (!localStorage.getItem('lang') && language == 'ar') {
			localStorage.setItem('lang', true);
            localStorage.setItem('language', "arab");
            this.setState({Language : "arab"});
            // location.reload();
		}
    }
    
    render(){

        return <div className="IndexMain ">
            <TopPafeInfo session={this.props.session}/>
            <div className="IndexMainMainPart">
                {/*
                <div className="IndexMainPackage">
                    <div className="IndexMainElementIn">
                        <div className="StandartElementTitle">{indexLang.title[this.state.Language]} <span style={{color: '#D8B168'}}>{indexLang.title2[this.state.Language]} <a style={{color: '#D8B168'}} href="https://youtu.be/VPGQ8Zkyj0w" target="_blank">{indexLang.title3[this.state.Language]}</a>)</span></div>
                        <div className="StandartElementTopBorder" />
                    </div>
                    
                    <div className="row">
                        <div class="col-md-4 col-sm-12">
                            <BronzeOffer session={this.state.session} reload={false}/>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <SilverOffer session={this.state.session} reload={false}/>
                        </div>
                        <div class="col-md-4 col-sm-12">
                            <GoldOffer session={this.state.session} reload={false}/>
                        </div>
                    </div>
                    <div className="row mt20px only-white">
                        <div className="col-md-12 text-center" style={{color: '#D8B168'}}>
                            {indexLang.support[this.state.Language]}<br/>
                            {indexLang.support2[this.state.Language]}<br/>
                            {indexLang.support3[this.state.Language]} <a style={{color: '#D8B168'}} href="https://t.me/artyfactsupport" target="_blank">{indexLang.support4[this.state.Language]}</a>.
                            <br/><br/>
                        </div>
                    </div>
                    <div className="row mt20px only-white">
                        <div className="col-md-12 text-center">
                            {indexLang.accept[this.state.Language]}<br/>
                            <img className="CoinAcceptImg ml5px" src={BTC} />
                            <img className="CoinAcceptImg" src={ETH} />
                            <img className="CoinAcceptImg" src={LTC} />
                            <img className="CoinAcceptImg" src={USDT} />
                            <img className="CoinAcceptImg" src={BNB} />
                            <img className="CoinAcceptImg" src={BUSD} />
                            {/*<img className="CoinAcceptImg2" src={paypal} /> 
                            <img className="CoinAcceptImg2" src={payeer} />*/} {/*
                            <br/><br/>
                        </div>
                    </div>
                </div> 
                */}

                {/* <div className="IndexMainExchenge">
                    <div className="IndexMainElementIn">
                        <div className="StandartElementTitle">{indexLang.current_round[this.state.Language]}</div>
                        <div className="StandartElementTopBorder"/>
                    </div>
                    <div className="IndexMainUserBalancesGrid MainExchangeStyle">
                        <img className="img-fluid" src={icoinfo} /> */}
                        {/*<div class="ico-area">
                            <div class="ico-ttl">IEO</div>
                        
                            <div class="ico-desc">Current: 2nd round</div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="ico-round br1px">
                                        <div class="ico-r-ttl">
                                            First round cost
                                        </div>
                                        <div class="ico-r-cost">
                                            CLOSED
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="ico-round">
                                        <div class="ico-r-ttl">
                                            Second round cost
                                        </div>
                                        <div class="ico-r-cost">
                                            CLOSED
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                   {/* </div>                    
                </div>*/}
                
                <div className="IndexMainQuickBar">
                    <div className="IndexMainElementIn">
                        <div className="StandartElementTitle">{indexLang.token_info[this.state.Language]}</div>
                        <div className="StandartElementTopBorder"/>
                            <div class="row">
                                <div class="col-md-12 only-white">
                                    <p style={{'font-weight': '500'}}>
                                        {indexLang.token_info2[this.state.Language]}
                                    </p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <ul class="about-ul only-white">
                                        <li>{indexLang.token_info3[this.state.Language]}</li>
                                        <li>{indexLang.token_info4[this.state.Language]}</li>
                                        <li>{indexLang.token_info5[this.state.Language]}</li>
                                    </ul>
                                </div>
                                <div class="col-md-6">
                                    <ul class="about-ul only-white">
                                        <li>{indexLang.token_info6[this.state.Language]}</li>
                                        <li>{indexLang.token_info7[this.state.Language]}</li>
                                        <li>{indexLang.token_info8[this.state.Language]}</li>
                                    </ul>
                                </div>
                            </div>                                            
                        </div>
                    </div>
                    {/*    
                    <div className="IndexMainAccReservesAndTotalBalance">
                        <div className="IndexMainAccReserves">
                            <div className="IndexMainElementIn">
                                <div className="StandartElementTitle">{indexLang.sale_events[this.state.Language]}</div>
                                <div className="StandartElementTopBorder"/>
                            </div>
                            <div class="row post-main-area">
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gold-bg-sale">{indexLang.seed[this.state.Language]}</span>
                                            <div class="sale-date">{indexLang.ongoing[this.state.Language]}</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.25 $</span> per $ARTY<br/>
                                            5 {indexLang.supply[this.state.Language]}<br/>
                                            2500 $ {indexLang.min_invest[this.state.Language]}<br/>
                                            1000000 $ {indexLang.max_invest[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale">{indexLang.private_sale[this.state.Language]}</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.35 $</span> per $ARTY<br/>
                                            2 {indexLang.supply[this.state.Language]}<br/>
                                            1000 $ {indexLang.min_invest[this.state.Language]}<br/>
                                            1000000 $ {indexLang.max_invest[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale">{indexLang.presale[this.state.Language]}</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.45 $</span> per $ARTY<br/>
                                            2 {indexLang.supply[this.state.Language]}<br/>
                                            1000 $ {indexLang.min_invest[this.state.Language]}<br/>
                                            750000 $ {indexLang.max_invest[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row post-main-area">
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale"> {indexLang.public_sale[this.state.Language]}</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.55 $</span> per $ARTY<br/>
                                            1 {indexLang.supply[this.state.Language]}<br/>
                                            250 $ {indexLang.min_invest[this.state.Language]}<br/>
                                            500000 $ {indexLang.max_invest[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale">IDO (TGE)</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.60 $</span> per $ARTY<br/>
                                            1 {indexLang.supply[this.state.Language]}<br/>
                                            100 $ {indexLang.min_invest[this.state.Language]}<br/>
                                            250000 $ {indexLang.max_invest[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale">PancakeSwap</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.65 $</span> per $ARTY<br/>
                                            {indexLang.more_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row post-main-area pb20px">
                                <div className="col-md-4 col-sm-12">
                                    <div class="user-block">
                                        <div class="sale-line">
                                            <span class="gray-bg-sale">Gate.io</span>
                                            <div class="sale-date">TBA</div>
                                        </div>
                                        <hr/>
                                        <div class="sale-desc2">
                                            <span>0.65 $</span> per $ARTY<br/>
                                            {indexLang.more_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>

                    <LatestNews />
                    */}
                </div>
            </div>
    }
}

export default withAuth(session => session && session.getCurrentUser)(withRouter(IndexMain));